/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';

function ImageSlider({ images, interval = 3000 }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!isHovered) {
        nextImage();
      }
    }, interval);

    return () => clearInterval(intervalId);
  }, [currentImageIndex, interval, isHovered]);

  return (
    <div
      className='d-flex flex-wrap pt-5 align-items-center'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className='col-12 col-lg-6 p-4 '>
        <div className='choose-banner'>
          <img
            className='img-fluid'
            src={images[currentImageIndex].image}
            alt='stock market tips'
          />
          <div>
            {images.map((image, index) => (
              <span
                key={image.id}
                aria-hidden
                onClick={() => handleDotClick(index)}
                style={{
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  margin: '0 5px',
                  borderRadius: '50%',
                  backgroundColor:
                    index === currentImageIndex ? '#3C86DD' : '#DFF0FD',
                  cursor: 'pointer',
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <div className='col-12 col-lg-6' style={{ height: '350px' }}>
        <p
          style={{ color: '#000', fontWeight: '500', fontSize: 20 }}
          className='p-4'
        >
          {images[currentImageIndex].content}
        </p>
      </div>
    </div>
  );
}

export default ImageSlider;
